export default {
  // Phiếu thu
  CAReceipt: 20,
  // Phiếu chi
  CAPayment: 21,
  // Nộp tiền Kho bạc
  BADeposit: 30,
  // Rút tiền Kho bạc
  BUTreasuryWithdrawal: 31,
  // Chuyển tiền nội bộ
  BAInternalTransfer: 32,
  // Chi tiền gửi
  BAWithDraw: 33,
  // Chuyển khoản kho bạc
  BUTransfer: 34,
  // Chuyển khoản kho bạc vào tài khoản tiền gửi
  BUTransferDeposit: 165,

  // Nhập khác
  INInward: 60,
  // Phiếu xuất kho
  INOutward: 61,
  // Nhập mua bằng tiền mặt
  InventoryInwardCash: 62,
  // Nhập mua bằng tiền gửi
  InventoryInwardDeposit: 63,
  // Chuyển kho
  InventoryTransfer: 64,
  // Ghi tăng TSCĐ
  FixedAssetIncrement: 70,
  // Ghi giảm TSCĐ
  FixedAssetDecrement: 71,
  // Điều chỉnh TSCĐ
  FixedAssetAdjustment: 72,
  // Khấu hao TSCĐ
  FixedAssetDepreciation: 73,
  // Ghi tăng CCDC
  ToolIncrement: 74,
  // Ghi giảm CCDC
  ToolDecrement: 75,
  // Điều chuyển CCDC
  ToolTransfer: 77,
  // Chứng từ nghiệp vụ khác
  SUGeneralVoucher: 100,
  // Phiếu kết chuyển tài khoản
  SUAccountTransfer: 101,
  // Chứng từ ghi đồng thời
  ParallelVoucher: 106,
  // Kết chuyển chênh lệch thu, chi ngân sách xã
  TranferReceiptClear: 130,
  // Kết chuyển cuối năm
  TranferClosing: 132,
  // Kết chuyển kết dư sang thu ngân sách xã
  TransferBudgetBalance: 133,
  // Kết chuyển hoạt động sự nghiệp
  TransferActivity: 134,
  // Quyết toán dự toán chi ngân sách cuối năm
  TransferBegining: 135,
  // Kết chuyển chênh lêhcj thu, chi ngân sách trong thời gian chỉnh lý
  TranferReceiptClearInMonth13: 136,
  // Nhận dự toán đầu năm
  BUReceiveBudgetPlan: 154,
  // Nhận dự toán bổ sung
  BUReceiveBudgetPlanSupplement: 155,
  // Điều chỉnh dự toán
  BUPlanAdjustment: 156,
  // Hủy dự toán
  BUPlanCancel: 157,
  // Điều chỉnh kinh phí
  BUExpenseWithdrawAdjustment: 652,
  // Hạch toán chi phí lương
  GlPayrollExpense: 81,
  // Ghi tăng TSCĐ từ QLTS.VN
  FAVoucherIncreament: 410,
  // Điều chỉnh TSCĐ từ QLTS.VN
  FAVoucherAdjustment: 411,
  // Lấy khấu hao TSCĐ từ QLTS.VN
  FAVoucherDepreciate: 412,
  // Hao mòn TSCĐ từ QLTS.VN
  FAVoucherDepreciation: 413,
  // Ghi giảm TSCĐ từ QLTS.VN
  FAVoucherDecrement: 414,
};
